import React from 'react';
import { useTranslation } from 'react-i18next';
import { IPInfoResponse } from '../../../types/interfaces';
import IPCountriesMap  from '../../../components/Home/IPCountriesMap';
import TopCountries    from '../../../components/Home/TopCountries';

interface IPInfoSectionProps {
  domains:        string[];
  selectedDomain: string;
  onDomainChange: (domain: string) => void;
  ipInfoList:     IPInfoResponse[];
}

export const IPInfoSection: React.FC<IPInfoSectionProps> = ({
  domains,
  selectedDomain,
  onDomainChange,
  ipInfoList,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-lg shadow p-6">
      {/* Título */}
      <div>
        <div className="flex items-center mb-4">
          <div className="w-3 h-10 bg-gray-800 mr-4"></div>
          <h3 className="text-2xl md:text-3xl font-bold">{t('ipinfoSection.title')}</h3>
        </div>
        {/* Descripción */}
        <p className="text-gray-700 mb-4 text-xl">
          {t('ipinfoSection.description')}
        </p>
      </div>

      {/* Selector de dominio */}
      <div className="mb-6">
        <label htmlFor="ipinfo-domain-select" className="block text-2xl font-medium text-gray-700 mb-4">
          {t('ipinfoSection.select_domain')}
        </label>
        <select
          id="ipinfo-domain-select"
          value={selectedDomain}
          onChange={e => onDomainChange(e.target.value)}
          className="block w-full max-w-md mt-1 p-2 border border-gray-800 bg-gray-800 text-white font-bold rounded-md"
        >
          {domains.map(d => (
            <option key={d} value={d} className="bg-white text-gray-800">
              {d}
            </option>
          ))}
        </select>
      </div>

      {/* Contenido: Mapa y TopCountries side by side */}
      <div className="flex flex-col lg:flex-row gap-6 h-96 overflow-hidden">
        {/* Mapa */}
        <div className="flex-1 h-full overflow-hidden relative">
          {ipInfoList.length > 0 ? (
            <IPCountriesMap ipInfoList={ipInfoList} />
          ) : (
            <div className="bg-gray-100 h-full flex items-center justify-center rounded">
              <p className="text-gray-600">{t('ipinfoSection.no_locations')}</p>
            </div>
          )}
        </div>

        {/* Top países */}
        <div className="flex-1 h-full overflow-auto">
          <h4 className="text-lg font-semibold mb-2 text-center">
            {t('ipinfoSection.top_countries')}
          </h4>
          {ipInfoList.length > 0 ? (
            <TopCountries ipInfoList={ipInfoList} />
          ) : (
            <p className="text-gray-600 text-center">
              {t('ipinfoSection.no_locations')}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
